import { AppProps } from "next/app";
import Head from "next/head";

import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@/lib/styles.css";
import Script from "next/script";

function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GTM_TRACKING_ID}`}
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GTM_TRACKING_ID}', {
            page_path: window.location.pathname,
            });
        `}
      </Script>
      <Head>
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <title>Project Electric Sheep</title>
        <meta name="title" content="Project Electric Sheep" />
        <meta
          name="description"
          content="Project Electric Sheep is a conversational dream simulator, which combines automatic content creation from AI models with 3D games technology to create an experiment in how AI will influence the future of creativity."
        />
        <meta property="og:title" content="Project Electric Sheep" />
        <meta
          property="og:description"
          content="Project Electric Sheep is a conversational dream simulator, which combines automatic content creation from AI models with 3D games technology to create an experiment in how AI will influence the future of creativity."
        />
        <meta
          property="og:image"
          content="https://www.projectelectricsheep.com/static/built-by-ai.png"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="icon" type="image/png" href="/static/sheep.png" />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default App;
